import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useAuthModal } from "@/context/AuthModalContext";
import RootRoute from "@/components/RootRoute";

/**
 * Routes /login and /register render the public landing behind the global
 * auth modal (opened for the matching mode), so direct URLs and protected-route
 * redirects still surface the sign in / sign up experience.
 */
export default function AuthRoute({ mode }) {
  const { user, loading } = useAuth();
  const { openAuth } = useAuthModal();
  useEffect(() => {
    if (!loading && !user) openAuth(mode);
  }, [loading, user, mode, openAuth]);
  return <RootRoute />;
}
